<template>

  <md-report-layout :header-buttons="headerButtons">

    <template v-slot:header-left>
      <md-date-select mode="monthlyRange"
                      :init-start="rangeStart"
                      :init-end="rangeEnd"
                      @change="dateRangeChanged"
                      display-mode="header"/>
    </template>

    <template v-slot:employee-list>
      <ReportConfig :options="reportConfigOptions" @configChanged="reportConfigChanged"/>
    </template>

    <template v-slot:report-settings>
      <div style="text-align:left; font-weight:bold; font-size: 20px;">
        {{ $t('report.main.reportList') }}
      </div>

      <div  class="reports-list">
          <datatablesimple :state="reportState" />
      </div>
      <div v-if="reports.length == 0">
        {{ $t('report.main.noReportsCreated') }}
      </div>
    </template>

    <template v-slot:default>
      <div v-if="loading" class="loading-md bg">
        <i class="fas fa-spinner"></i>
        <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
          {{ loadingText }}
        </div>
      </div>
    </template>

    <template v-slot:button-bar v-if="creatingReport">
      <span>
        <i class="fas fa-circle-notch fa-spin"></i>
        {{ $t('report.main.reportCreating') }}
      </span>
    </template>
  </md-report-layout>

</template>

<script>
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';
import MdDateSelect from '@/components/uicomponents/md-date-select';
import MdReportLayout from '@/components/reportcontext/ReportLayout';
import ReportConfig from '@/shared/components/ReportConfig.vue';

export default {
  name: 'reportharaldfaschingspecial',
  components: {
      ReportConfig,
    MdReportLayout,
    MdDateSelect,
  },
  data() {
    return {
      loadingText: this.$t('report.main.loadX', ['HFA']),
      loading: true,
      loadingEmployees: true,
      showEmployeeNameFilter: true,
      reportConfig: {},

      reportYear: this.$helpers.getCurrentMonthMomentTZ().year(),
      reportMonth: this.$helpers.getCurrentMonthMomentTZ().month() + 1,
      reportMonthText: [
        '',
        this.$t('global.general.month1At'),
        this.$t('global.general.month2'),
        this.$t('global.general.month3'),
        this.$t('global.general.month4'),
        this.$t('global.general.month5'),
        this.$t('global.general.month6'),
        this.$t('global.general.month7'),
        this.$t('global.general.month8'),
        this.$t('global.general.month9'),
        this.$t('global.general.month10'),
        this.$t('global.general.month11'),
        this.$t('global.general.month12'),
      ],
      reportFormat: 'csv',

      filterEmployees: '',
      reportname: '',
      reportcomment: '',
      reportShowSalaries: true,

      creatingReport: false,

      fields: [
        {
          key: 'name',
          label: this.$t('report.main.documentName'),
          sortable: true,
        },
        {
          key: 'creationDate',
          label: this.$t('global.menubar.sortOptionCreationDate'),
          sortable: true,
        },
        {
          key: 'actions',
          label: '',
          sortable: false,
        },
      ],
      reports: [],

      employeeList: [],

      toggleFilename: true,
      toggleComment: false,
      toggleFileFormat: false,
      toggleFileContent: false,
      toggleCalculationModel: false,
      toggleHourFormat: false,
      toggleSortMethod: false,
      toggleHeaderDateFormat: false,
      toggleDocumentFormat: false,

      settingDateFormat: 'DD.MM.YYYY',
      settingEmployeeFormat: 'one',
      settingSignatureLine: true,
      settingColorFormat: 'color',
      settingFontSize: 'default',
      settingHourFormat: 'Hm',
      settingFileContentLineOne: true,
      settingFileContentLineTwo: true,
      settingFileContentLineThree: true,
      headerShowQr: true,

      recalcEmployeeCounter: 1,
      activeInactive: 'showActive',
    }
  },
  mounted: function () {
    if (this.$store.state.jwt != undefined && this.$store.state.storeId != undefined) {
      this.reportYear = this.$helpers.getCurrentMonthMomentTZ().year();
      this.reportMonth = this.$helpers.getCurrentMonthMomentTZ().month() + 1;
      this.reportname = 'HFA Feport , ' + this.reportMonthText[this.reportMonth] + ' ' + this.reportYear;
      try {
        let config = JSON.parse(localStorage.reportCorrectionEventlogConfig);
        this.settingHourFormat = config.settingHourFormat;
        this.settingEmployeeFormat = config.settingEmployeeFormat;
        this.settingSignatureLine = config.settingSignatureLine;
        this.settingColorFormat = config.settingColorFormat;
        (config.settingFontSize == null) ? this.settingFontSize = 'default' : this.settingFontSize = config.settingFontSize;
        this.settingDateFormat = config.settingDateFormat;
        this.headerShowQr = config.headerShowQr != null ? config.headerShowQr : true;
        this.settingFileContentLineOne = config.settingFileContentLineOne;
        this.settingFileContentLineTwo = config.settingFileContentLineTwo;
        this.settingFileContentLineThree = config.settingFileContentLineThree;
      } catch (ex) {
        console.error(ex);
      }
      this.refresh();
    }
  },
  created: function () {
  },
  computed: {
    ...mapGetters([ 'storeId', 'userInfo', 'rosterFromTo', 'anonMode']),
    headerButtons() {
      let view = this;
      let helperLinks = [];
      let buttons = [
        {
          classes: 'add-employeetype',
          type: 'block gray',
          disabled: false,
          icon: 'fa-th-list',
          click: ($event) => {
          },
          show: true,
          tooltip: 'HFA-Report',
          title: 'HFA-Report',
        },
        {
          type: 'block green',
          disabled: this.creatingReport,
          icon: this.creatingReport ? 'fa-redo' : 'fa-file-check',
          click: ($event) => {
            this.createReport();
          },
          show: true,
          tooltip: this.$t('global.ui.createX', [this.$t('roster.view.report')]),
        },
      ];
      let state = {
        buttons: buttons,
        helperLinks: helperLinks,
        showListIconAlways: true,
      };

      state.helperLinks = [
        {
          title: 'HFA Report',
          helperText: this.$t('report.main.hfaReport'),
          externalUrl: 'https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/15',
          externalLabel:  this.$t('store.structure.getSupportLabel'),
          cancelLabel: this.$t('global.ui.close'),
        },
        {
          title:  this.$t('store.structure.getSupport'),
          helperText: this.$t('store.structure.getSupportHelp'),
          externalUrl: 'https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/15',
          externalLabel:  this.$t('store.structure.getSupportLabel'),
          cancelLabel: this.$t('global.ui.close'),
        },
      ];
      return state;
    },

    rangeStart() {
      const date = moment();
      date.set({ year: this.reportYear, month: this.reportMonth - 1 });
      console.log(date.format())
      return date;
    },

    rangeEnd() {
      const date = moment(this.rangeStart);
      date.endOf('month');
      return date;
    },

    reportConfigOptions() {
      return [
        {
          title: this.$t('report.main.documentName'), key: 'docName', expanded: true, options: [
            { key: 'reportname', type: 'text', placeholder: this.$t('report.main.enterDocumentName'), currentValue: this.reportname },
          ],
        },
      ];
    },
      reportState() {
          if (this.reports === undefined || this.reports.length < 1) {
              return null;
          }

          let data = Object.values(this.reports);

          let columns = {
              name: this.$t('report.main.documentName'),
              creationDate: this.$t('global.menubar.sortOptionCreationDate'),
              actions: ' ',
          };

          let state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

          this.$helpers.buildHeaderMapLabel(state.headerMap, 'name');
          this.$helpers.buildHeaderMapLabel(state.headerMap, 'creationDate');
          this.$helpers.buildHeaderMapLabel(state.headerMap, 'actions');
          state.headerMap.actions.componentStateBuilders = [
              (data) => {
                  return {
                      componentType: 'buttonc',
                      tooltip: () => {
                          return this.$t('global.general.download');
                      },
                      type: 'button square rounded no-border green',
                      icon: 'fas fa-download',
                      customEvents: {
                          click: () => {
                              this.$helpers.DownloadFileFromFileServer(data.url, data.name, 'csv');
                          },
                      },
                  };
              },
              (data) => {
                  return {
                      componentType: 'buttonc',
                      tooltip: () => {
                          return this.$t('global.ui.delete');
                      },
                      type: 'button square rounded no-border red',
                      icon: 'fas fa-trash',
                      customEvents: {
                          click: () => {
                              this.openDeleteReportPopup(data);
                          },
                      },
                  };
              },
          ];

          let entries = Object.entries(state.headerMap);

          entries[0][1].key = 'name';
          entries[0][1].width = '60%';
          entries[1][1].key = 'creationDate';
          entries[1][1].width = '25%';
          entries[2][1].key = 'actions';
          entries[2][1].width = '15%';

          state.headerStyles = { fontSize: '10px', position: 'sticky', top: 0, zIndex: 10 };
          state.heightSubRow = 'fit-content';
          state.rowStylesCollapsed = this.strippedRowStyle();
          state.alwaysUnfold = false;

          return state;
      },
  },
  watch: {
    storeId(newVal, oldVal) {
      this.refresh();
    },
  },
  // methods that implement data logic.
  methods: {
    dateRangeChanged({ from, to, mode }) {
      this.reportYear = moment(from).year();
      this.reportMonth = moment(from).month() + 1;

      this.reportname = 'HFA Report , ' + this.reportMonthText[this.reportMonth] + ' ' + this.reportYear;
      this.recalcEmployeeCounter++;
      this.loadEmployees();
    },

    saveLocalStorage: function () {
      let config = {
        'settingHourFormat': this.settingHourFormat,
        'settingEmployeeFormat': this.settingEmployeeFormat,
        'settingSignatureLine': this.settingSignatureLine,
        'settingColorFormat': this.settingColorFormat,
        'settingFontSize': this.settingFontSize,
        'settingDateFormat': this.settingDateFormat,
        'headerShowQr': this.headerShowQr,
        'settingFileContentLineOne': this.settingFileContentLineOne,
        'settingFileContentLineTwo': this.settingFileContentLineTwo,
        'settingFileContentLineThree': this.settingFileContentLineThree,
      };
      localStorage.reportCorrectionEventlogConfig = JSON.stringify(config);
    },
    refresh: function () {
      let view = this;
      this.loading = true;
      this.loadingEmployees = true;
      this.reportname = 'HFA Report , ' + this.reportMonthText[this.reportMonth] + ' ' + this.reportYear;
      this.loadReports();
      this.loadEmployees();
    },
    loadEmployees: function () {
      let view = this;
      this.loadingEmployees = true;
      view.loadEmployeesAxios().then(response => {
        view.employeeList = [];
        view.employeeMap = {};
        view.employees = response.data;
        view.employees.forEach(e => view.employeeMap[e.id] = e);

        for (let i in view.employees) {
          let employee = view.employees[i];
          view.employeeList.push(employee);
        }
        for (let i in view.employeeList) {
          let employee = view.employeeList[i];
          employee.selected = true;
          employee.visible = true;
        }
        view.employeeList.sort(this.compare);
      });
      setTimeout(function () {
        view.loading = false;
        view.loadingEmployees = false;
      }, 500);
    },
    loadEmployeesAxios: function () {
      let url = '/api/sec/employee';
      let params = {
        storeId: this.$store.state.storeId,
      };
      if (this.activeInactive == 'showActive') {
        params = {
          storeId: this.$store.state.storeId,
          contract: true,
          activeAtFrom: this.$helpers.getMomentTZ().year(this.reportYear).month(this.reportMonth - 1).startOf('month').format(),
          activeAtTo: this.$helpers.getMomentTZ().year(this.reportYear).month(this.reportMonth - 1).endOf('month').format(),
        };
      }
      return this.axios({
        method: 'get',
        params: params,
        headers: {
          'AUTHORIZATION': 'bearer ' + this.$store.state.jwt,
        },
        url: url,
      })
    },

    changeSelection: function (method) {
      if (method == 'down') {
        this.reportMonth--;
      } else {
        this.reportMonth++;
      }
      if (this.reportMonth <= 0) {
        this.reportMonth = 12;
        this.reportYear--;
      }
      if (this.reportMonth >= 13) {
        this.reportMonth = 1;
        this.reportYear++;
      }
      this.reportname = 'HFA Report , ' + this.reportMonthText[this.reportMonth] + ' ' + this.reportYear;
      this.recalcEmployeeCounter++;
      this.loadEmployees();
    },

    reportConfigChanged(config) {
      Object.entries(config).forEach(([ key, value ]) => {
        this.$set(this, key, value);
      });
      this.saveLocalStorage();
    },

    createReport: function () {
      let view = this;
      this.creatingReport = true;
      let url = '/api/sec/report';
      url = this.$helpers.appendParam('storeId', this.$store.state.storeId, url, '/api/sec/report');

      let employeeIds = [];
      for (let i in this.employeeList) {
        if (this.employeeList[i].selected) {
          employeeIds.push(this.employeeList[i].id);
        }
      }

      let payload = {
        name: view.reportname,
        description: view.reportcomment,
        documentType: 'HARALDFASCHINGSPECIALREPORT',
        sensitive: false,
        config: {
          'storeId': parseInt(view.$store.state.storeId),
          'documentType': 'haraldfaschingspecialreport',
          'year': view.reportYear,
          'month': view.reportMonth,
          'employeeIds': employeeIds,
          'env': 'production',
          'documentComment': view.reportcomment,
        },
      };

      this.axios({
        method: 'post',
        headers: {
          'AUTHORIZATION': 'bearer ' + this.$store.state.jwt,
        },
        url: url,
        data: payload,
      }).then(response => {
        view.loadReports();
        setTimeout(function () {
          view.creatingReport = false;
        }, 200);
      }).catch(function (error) {
        view.loadReports();
        setTimeout(function () {
          view.creatingReport = false;
        }, 200);
      });
    },

    loadReports() {
      let view = this;
      let url = '/api/sec/storefile';

      let params = {
        storeId: this.$store.state.storeId,
        documentType: 'HARALDFASCHINGSPECIALREPORT',
        //from: this.rosterFromTo.from,
        //to: this.rosterFromTo.to
      }
      this.axios({
        method: 'get',
        headers: {
          'AUTHORIZATION': 'bearer ' + this.$store.state.jwt,
        },
        url: url,
        params: params,
      }).then((response) => {
        view.reports = [];
        let data = response.data;
        for (let i in data) {
          let row = data[i];
          if (row.documentType != 'HARALDFASCHINGSPECIALREPORT') continue;
          let elem = {
            'id': row.id,
            'name': row.name,
            'comment': (row.description == null) ? '' : row.description.substring(0, 32),
            'format': row.fileType,
            'creationDate': view.$helpers.getMomentFromString(row.creationDate).format('DD.MM.YYYY  HH:mm'),
            'url': row.url + '/api/file?id=' + row.fileId + '&accessToken=' + row.accessToken,
          };
          view.reports.push(elem);
        }
      });
    },
    openDeleteReportPopup(row) {
      let view = this;
      window.app.popupalerts.push(
          {
            header: this.$t('global.ui.deleteX', [this.$t('roster.view.report')]),
            description: this.$t('report.main.deleteReportQuery'),
            hidden: false,
            callbackAccept: function (popup) {
              popup.hidden = true;
              view.deleteReport(row.id);
            }
            , callbackCancel: function (popup) {
              popup.hidden = true;
            },
          });
    },
    deleteReport(id) {
      let view = this;
      let url = '/api/sec/report';
      let params = {
        storeId: this.$store.state.storeId,
        id: id,
      }


      this.axios({
        method: 'delete',
        headers: {
          'AUTHORIZATION': 'Bearer ' + this.$store.state.jwt,
        },
        url: url,
        params: params,
      }).then((response) => {
        view.reports = view.reports.filter(r => r.id != id);
        view.$helpers.success(view.$t('global.notifications.success'), this.$t('global.ui.deletedX', [this.$t('roster.view.report')]));
      }).catch(error => {
        view.$helpers.error(view.$t('global.notifications.error'), this.$t('global.ui.deletedErrorX', [this.$t('roster.view.report')]));
      });
    },
    getImageUrl(employee) {
      if (employee.employeePicture != null) {
        return employee.employeePicture.server + '/api/file?id=' + employee.employeePicture.fileId + '&accessToken=' + employee.employeePicture.accessToken;
      }
      return '../img/avatar.png';
    },

    compare: function (a, b) {
      if (a.lastName < b.lastName)
        return -1;
      if (a.lastName > b.lastName)
        return 1;
      if (a.firstName < b.firstName)
        return -1;
      if (a.firstName > b.firstName)
        return 1;
      return 0;
    },
    strippedRowStyle() {
        return (rowData, row, index, datatable) => {
            if (index % 2 === 0) {
                return {'background' : 'var(--contrast-2)'};
            } else {
                return {'background' : 'var(--contrast-0)'};
            }
        };
    },
  },
}
</script>

<style>
.b-table-sticky-header.hfa-report-list {
  max-height: calc(100vh - 192px);
}

.row-container .label {
    color: var(--contrast-4)!important;
}

.row-container {
    border-radius: 0!important;
}
</style>
